import React from "react";
import { AuthConsumer } from "../../../Helpers/auth.provider";

export const Callback = () => (
    <AuthConsumer>
        {({ signinRedirectCallback}) => {
            signinRedirectCallback();
            return <span>loading</span>;
        }}
    </AuthConsumer>
);